import React from 'react';
import { List, Empty } from 'antd';
import { FileSearchOutlined } from '@ant-design/icons';
import SearchInput from './SearchInput';

const getTemplateTitle = (tpl) => tpl?.inspectionName || tpl?.name || tpl?.templateName || `Template ${tpl?.id || ''}`;
const getTemplateDescription = (tpl) => tpl?.description || tpl?.inspectionType || null;

const InspectionList = ({ templates = [], onSelect, onSearch, searchValue = '', loading = false }) => {
  if (!templates || templates.length === 0) {
    return (
      <div>
        <SearchInput
          placeholder="Search inspections..."
          value={searchValue}
          onChange={onSearch}
          loading={loading}
        />
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No inspection templates available"
        />
      </div>
    );
  }

  return (
    <div style={{ padding: '0 16px' }}>
      <SearchInput
        placeholder="Search inspections..."
        value={searchValue}
        onChange={onSearch}
        loading={loading}
      />
      <List
        itemLayout="horizontal"
        dataSource={templates}
        loading={loading}
        renderItem={(tpl) => (
        <List.Item
          key={tpl.id || getTemplateTitle(tpl)}
          onClick={() => onSelect?.(tpl)}
          style={{ cursor: 'pointer' }}
        >
          <List.Item.Meta
            avatar={<FileSearchOutlined style={{ fontSize: 20 }} />}
            title={getTemplateTitle(tpl)}
            description={getTemplateDescription(tpl)}
          />
        </List.Item>
      )}
      locale={{
        emptyText: searchValue ? 'No matching inspections found' : 'No inspection templates available'
      }}
    />
  </div>
  );
};

export default InspectionList;
